import React, { FC } from 'react'

import cn from 'classnames'
import { Link } from 'gatsby'

import classes from './level-button.module.scss'
import { ButtonProps, Level } from './level-button.types'

const levelClass: Record<Level, string> = {
  [Level.Primary]: classes.primary,
  [Level.Secondary]: classes.secondary,
  [Level.Tertiary]: classes.tertiary,
  [Level.Quaternary]: classes.quaternary,
  [Level.Quinary]: classes.quinary,
  [Level.Link]: classes.link,
  [Level.UnstyledLink]: classes.unstyledLink,
}

export const LevelButton: FC<ButtonProps> = ({
  children,
  dataTestId = 'button',
  disabled = false,
  id,
  level,
  onClick,
  to,
}) => {
  const buttonClass = cn(
    classes.button,
    levelClass[level],
    disabled && classes.disabled
  )

  return to ? (
    <Link
      className={buttonClass}
      data-testid={dataTestId}
      id={id}
      tabIndex={0}
      to={to}
    >
      <span className={classes.buttonText} data-testid={`${dataTestId}-text`}>
        {children}
      </span>
    </Link>
  ) : (
    <button
      className={buttonClass}
      data-testid={dataTestId}
      disabled={disabled}
      id={id}
      onClick={onClick}
      tabIndex={0}
    >
      <span className={classes.buttonText} data-testid={`${dataTestId}-text`}>
        {children}
      </span>
    </button>
  )
}

export default LevelButton
